import React from 'react';
import { Search, Users, Mail, MessageCircle, ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Label } from '../../ui/label';
import { Badge } from '../../ui/badge';

export const ClientSelector = ({
    clients,
    selectedClients,
    clientSearch,
    onSearchChange,
    onToggle,
    onSelectAll,
    showList,
    onToggleList,
}) => {
    const filtered = clients.filter(c =>
        (c.company_name || '').toLowerCase().includes(clientSearch.toLowerCase()) ||
        (c.contact_name || '').toLowerCase().includes(clientSearch.toLowerCase())
    );

    return (
        <div>
            <div className="flex items-center justify-between mb-2">
                <Label className="flex items-center gap-2">
                    <Users className="w-4 h-4 text-blue-600" />
                    Clients ({selectedClients.length} sélectionnés)
                </Label>
                <div className="flex gap-2">
                    <Button variant="ghost" size="sm" onClick={onSelectAll} className="text-xs">
                        Tout {filtered.every(c => selectedClients.find(sc => sc.id === c.id)) ? 'désélect.' : 'sélect.'}
                    </Button>
                    <Button variant="ghost" size="sm" onClick={onToggleList} className="text-xs">
                        {showList ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
                    </Button>
                </div>
            </div>
            {selectedClients.length > 0 && (
                <div className="flex flex-wrap gap-1.5 mb-2">
                    {selectedClients.slice(0, 10).map(c => (
                        <Badge key={c.id} variant="secondary" className="gap-1 bg-blue-50 text-blue-700 rounded-lg cursor-pointer hover:bg-red-50 hover:text-red-600" onClick={() => onToggle(c)}>
                            {c.company_name} ×
                        </Badge>
                    ))}
                    {selectedClients.length > 10 && (
                        <Badge variant="secondary" className="bg-gray-100 rounded-lg">
                            +{selectedClients.length - 10} autres
                        </Badge>
                    )}
                </div>
            )}
            {showList && (
                <div className="border rounded-xl p-3 space-y-2 max-h-52 overflow-y-auto bg-gray-50/50">
                    <div className="relative">
                        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-gray-400" />
                        <Input
                            value={clientSearch}
                            onChange={e => onSearchChange(e.target.value)}
                            placeholder="Rechercher un client..."
                            className="pl-8 h-8 text-sm rounded-lg"
                            data-testid="client-search"
                        />
                    </div>
                    {filtered.map(c => (
                        <button key={c.id} onClick={() => onToggle(c)}
                            className={`w-full flex items-center justify-between p-2 rounded-lg text-sm transition-colors ${
                                selectedClients.find(sc => sc.id === c.id) ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-100'
                            }`} data-testid={`client-item-${c.id}`}>
                            <span>{c.company_name}</span>
                            <div className="flex items-center gap-2 text-xs text-gray-400">
                                {c.phone && <MessageCircle className="w-3 h-3 text-green-500" />}
                                <Mail className="w-3 h-3" />
                            </div>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};
